import { useQuery } from 'react-query';

import { MatterCreditUsageDto } from '../../../../../backend/src/usage/dto/matter-credit-usage.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

// Per-matter credit usage breakdown for an org over an optional date range, optionally
// narrowed to a single matter.
export const useFetchOrgCreditByMatter = (
  enabled: boolean,
  organisationId: string,
  filters: { startDate?: Date; endDate?: Date; matterId?: string } = {},
) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const { startDate, endDate, matterId } = filters;

  return useQuery<MatterCreditUsageDto[]>(
    [QueryEntity.OrgCreditByMatter, { organisationId, startDate, endDate, matterId }],
    () => {
      const url = new URL(`${APIBaseChronos}/api/usage/credit-by-matter`);
      url.searchParams.append('organisationId', organisationId);
      if (startDate && endDate) {
        url.searchParams.append('startDate', startDate.toISOString());
        url.searchParams.append('endDate', endDate.toISOString());
      }
      if (matterId) {
        url.searchParams.append('matterId', matterId);
      }

      return fetch(url.toString(), {
        ...fetchConfigGET,
        method: FetchMethod.GET,
      })
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    },
  );
};
